import { faAsterisk, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";
import { Button } from "react-bootstrap";
import { Loader } from "react-bootstrap-typeahead";

interface EditableDataFieldProps {
    label: ReactNode | string;
    mandatory?: boolean;
    hideClearButton?: boolean;
    handleClear: () => void;
    children: ReactNode;
    long?: boolean;
    className?: string;
    loading?: boolean;
}

function ProfileEditContentNode({
    label,
    mandatory = false,
    hideClearButton = false,
    handleClear,
    children,
    long = false,
    className='',
    loading = false
}: EditableDataFieldProps) {
    const { t } = useTranslation(["common"]);

    return (
        <div className={`form-group-custom position-relative ${className}`}>
            {label && (
                <div className="dataNode-label">
                    {label}
                    {mandatory && label && (<span className="ms-1 text-danger"><FontAwesomeIcon icon={faAsterisk} /></span>)}
                    {loading ? <Loader /> : null}
                </div>
            )}
            <div className={`${hideClearButton ? "" :"content-container"}`}>
                {children}
                {!hideClearButton && (
                    <Button
                        variant="link"
                        className="form-control-input-custom-clear"
                        onClick={e => {
                            e.stopPropagation();
                            handleClear();
                        }}
                        aria-label={t("form.button.clear")}
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </Button>
                )}
            </div>
        </div>
    );
}

export default ProfileEditContentNode;
